<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
       
         <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
             <div class="col mt-4" :class="{ 'mb-5 mb-sm-0': !(roleId == 4) }">
                  <h4 >Reports</h4>
                </div>
              <div class="col d-flex justify-content-end" v-if="roleId == 4">
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-none d-sm-block new-btn"
                  @click="BackToServices()"
                >
                  Back To Services
                </llp-button>

                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-block d-sm-none new-btn"
                  @click="BackToServices()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
          </div>
        </div>
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center ">
          
             <div  v-if="selectedDate" class="d-flex align-items-center gap-3">
              <small class="selected-dates-text ">{{searchValue}}</small>
              <small class="selected-dates-text">
                      {{ formatAPIDate(dateRange[0]) }} to {{ formatAPIDate(dateRange[1]) }}
                      </small>
                       <button 
                        v-if="dateRange && dateRange.length > 0"
                        class="btn btn-sm btn-link clear-date-range"
                        @click="clearDateRange"
                      >
                        <i class="fa fa-times"></i> Clear
                      </button>
            </div>
                 <div class="row  align-items-center">
            <div class="col-lg-3 col-md-6 col-sm-12 mb-2 ">
              <llp-label id="username-label" class="col-form-label">
              Search:
              </llp-label>
              <llp-input
                id="username"
                class="search-by-names"
                v-model="searchValue"
                autocomplete="off"
                :placeHolder="`Enter Transaction ID/Status/Mode/Service`"
              />
            </div>
           
            <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
      <llp-label id="date-range-label" class="col-form-label">Select Date Range:</llp-label>

        <div class="date-range-container">
      <BaseCalendar
        v-model="dateRange"
        :selectionMode="'range'"
        :showButtonBar="true"
        :showIcon="true"
        :maxDate="new Date()"
        @dateSelect="handleDateSelect"
      />
     
    </div>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-12 mb-2 mt-3 mt-md-4">
              <llp-button classNames="btn-secondary" @click="fetchingDateReports">Search</llp-button>
            </div>
               </div>

                <div class="col  position-relative">
                  <div v-if="loading" class="loader-overlay">
                    <div class="spinner"></div>
                  </div>
                  <llp-datatable
                    ref="usersTable"
                    :columns="columns"
                    :data="reportsData"
                    :lazy="true"
                    :paginator="true"
                    :totalRecords="totalRecords"
                    :rows="perpage"
                    :page="currentPage"
                    scrollable
                      @onPageChange="onPageChange"
                  >
                    <template #actions="{ data }">
                      <div class="text-center">
                        <button
                          class="btn btn-secondary m-1 new-btn"
                          @click="ViewUserDetails(data.id)"
                        >
                          <i class="fa fa-eye"></i>
                        </button>
                        <button
                          class="btn btn-secondary m-1 new-btn"
                          @click="showInvoiceModal(data.id)"
                        >
                          <i class="fa fa-file-invoice"></i>
                        </button>
                        <button
                          class="btn btn-secondary m-1 new-btn"
                          @click="AddTicket()"
                        >
                          <i class="fa-solid fa-plus"></i>
                        </button>
                      </div>
                    </template>
                  </llp-datatable>
                </div>
             
            </div>
          </div>
        </div>
      </div>

      <!-- Invoice Modal -->
     <Dialog
        v-model:visible="visible"
        modal
        :style="{ width: '90%', maxWidth: '45rem' }"
        :breakpoints="{'960px': '75vw', '641px': '90vw'}"
      >
        <template #header>
            <h4 class="modal-title">Invoice</h4>
        </template>
        <div v-if="selectedInvoice" class="p-4 bg-white text-dark container-fluid">
          
          <div class="row mb-4 align-items-center">
            <div class="col-6">
              <img
                src="/images/makbilllogo.png"
                alt="Makbill Logo"
                class="img-fluid logo-in-modal w-100"
                style="max-width: 140px; height: auto;"
              />
            </div>
            <div class="col-6 text-end">
              <p class="mb-1"><strong>Invoice No:</strong> {{ selectedInvoice.id }}</p>
              <p class="mb-1">
                <strong>Date:</strong>
                {{ formatDate(selectedInvoice.created_at) }}
              </p>
              <p v-if="selectedInvoice.urn" class="mb-1">
                <strong>Transaction ID:</strong>
                {{ selectedInvoice.urn }}
              </p>
            </div>
          </div>

          <div class="row mb-4">
               <div class="col-12 col-md-6">
        <h5 class="fw-bold">Bill To:</h5>
        <p class="mb-1">
          <strong>Name:</strong> {{ selectedInvoice.name || "N/A" }}
        </p>
        <p class="mb-1">
          <strong>Email:</strong> {{ selectedInvoice.email || "N/A" }}
        </p>
        <p class="mb-1">
          <strong>Mobile:</strong> {{ selectedInvoice.mobile || "N/A" }}
        </p>
      <p class="mb-1">
  <strong>Address :</strong>
  <span style="white-space: pre-wrap;">{{ formattedAddress (userAddress.address) }}</span>
</p>
      </div>
            <div class="col-12 col-md-6 mb-3 text-md-end">
              <h5 class="fw-bold">Payment Details:</h5>
            
               <h6 class="mb-1">
                <strong>Payment Mode:</strong>
                {{ formatPaymentMode(selectedInvoice.payment_mode) }}
              </h6>
               <h6 class="mb-1">
                <strong>Payment Status:</strong>
                {{ formatPaymentMode(selectedInvoice.payment_status	) }}
              </h6>
            </div>
            
          </div>

          <table class="table table-bordered">
            <thead class="table-light user-table">
              <tr>
                <th>#</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ selectedInvoice.services?.name || "Service" }}</td>
                <td>1</td>
                <td>₹ {{ selectedInvoice.amount || "0.00" }}</td>
                <td>₹ {{ selectedInvoice.amount || "0.00" }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="4" class="text-end sub-total-text">Subtotal</th>
                <th class="sub-total-text">
                  ₹ {{ selectedInvoice.amount || "0.00" }}
                </th>
              </tr>
      
              <tr>
                <th colspan="4" class="text-end sub-total-text">Total</th>
                <th class="sub-total-text">
                  ₹ {{ selectedInvoice.amount || "0.00" }}
                </th>
              </tr>
            </tfoot>
          </table>

          <div class="text-end mt-3">
            <button class="btn btn-outline-secondary" @click="downloadInvoice">
              <i class="fa fa-download"></i> Download
            </button>
          </div>
        </div>
      </Dialog>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import Dialog from "primevue/dialog";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import NetworkService from "@/services/network.service";
import BaseCalendar from '@/components/Base/BaseCalendar.vue';
const today = new Date();
export default {
  components: { Dialog,BaseCalendar },
  
  data() {
    return {
      loading: true,
      selectedInvoice: null,
      searchValue:'',
      reportsData: [],
       dateRange: [today, today],
      currentPage: 1,
      perpage: 10,
      totalRecords: 0,
      userAddress:null,
      startDate:'',
      endDate:'',
      visible: false,
      selectedDate:false,
      userId: localStorage.getItem("User_id"),
      roleId:localStorage.getItem("role_id"),
      columns: [
        { field: "s_no", className: "text-center", header: "S.No" },
         {
          field: "payment_for",
          header: "Payment For",
          className: "text-center",
        },
        { field: "created_at", className: "text-center", header: "Date" },
        {
          field: "transaction_id",
          header: "Transaction ID",
          className: "text-center",
        },
        {
          field: "service_name",
          header: "Service Name",
          className: "text-center",
        },
        
        { field: "amount", header: "Total Amount", className: "text-center" },
        {
          field: "payment_mode",
          header: "Payment Mode",
          className: "text-center",
        },
        {
          field: "payment_status",
          header: "Payment Status",
          className: "text-center",
        },
        {
          field: "action",
          header: "Action",
          body: "actions",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
        },
      ],
    };
  },
  computed: {
    subtotal() {
      return parseFloat(this.selectedInvoice?.amount || 0);
    },
    gstAmount() {
      return 0; // GST seems to be 0 in your data
    },
    totalAmount() {
      return this.subtotal;
    },
  },
  mounted() {
    this.resetDataTable();
    this.fetchingReports();
  },
  watch: {
    "$route.params.roleName": function () {
      this.resetDataTable();
    },
  },
  methods: {
     handleDateSelect(range) {
    console.log("Selected range:", range);
  },
    formatPaymentMode(mode) {
  if (!mode) return "N/A";
  return mode
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
},
formattedAddress() {
    const address = this.userAddress?.address || "N/A";
    const words = address.split(/\s+/); 
    const chunks = [];

    for (let i = 0; i < words.length; i += 3) {
      chunks.push(words.slice(i, i + 3).join(" "));
    }

    return chunks.join('\n');
  },
      formatDate(dateString) {
  if (!dateString) return "N/A";

  // If ISO format (has 'T' or space)
  if (dateString.includes("T") || dateString.includes(" ")) {
    const isoString = dateString.replace(" ", "T");
    const date = new Date(isoString);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
  }

  // If DD-MM-YYYY format
  const parts = dateString.split("-");
  if (parts.length === 3) {
    const [day, month, year] = parts;
    const date = new Date(`${year}-${month}-${day}`); 
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
  }

  return "N/A";
},
    resetDataTable: function () {
      this.rows = [];
      this.totalRecords = 0;
      this.$refs.usersTable.resetPaginator();
    },
    async showInvoiceModal(id) {
      try {
        const invoiceResponse = await NetworkService.get(
          `transaction-invoice/${id}`
        );
        this.selectedInvoice = invoiceResponse.data;
        this.userAddress = invoiceResponse.user_details

        this.visible = true;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the invoice details", "error");
      }
    },
    ViewUserDetails(id) {
      this.$router.push({ name: "ViewReports", params: { id } });
    },
    AddTicket() {
      this.$router.push("/create-ticket");
    },
    BackToServices() {
      this.$router.push(`/services`);
    },
    onPageChange(event) {
      const { first, rows } = event;
      this.currentPage = first / rows + 1;
      this.perpage = rows;
      if(this.startDate && this.endDate)
      {
        this.fetchingDateReports(this.currentPage, this.perpage)
      }else{
this.fetchingReports(this.currentPage, this.perpage);
      }
      
    },
    clearDateRange()
    {
      this.startDate = "",
      this.endDate =""
      this.selectedDate = false;
      this.searchValue =""
      this.loading = true,
        this.fetchingReports()
    },
    async fetchingReports() {
      try {
        
        const reportResponse = await NetworkService.get(
          `/transaction-list/${this.userId}?per_page=${this.perpage}&&page=${this.currentPage}`
        );
        
        const responseData = reportResponse.data;
        const reports = reportResponse.data.data;
        const startIndex = (this.currentPage - 1) * this.perpage;

        this.reportsData = reports.map((report, index) => {
          return {
            s_no: startIndex + index + 1,
            created_at: this.formatDate(report.created_at),
            transaction_id: report.urn,
            service_name: report.service_name || report.services?.name || "N/A",
            amount: report.amount ? `₹ ${report.amount}` : "₹ 0.00",
            payment_mode: report.payment_mode || "N/A",
            payment_status: report.status,
            payment_for:report.payment_for || "N/A",
            id: report.id,
          };
        });
        this.totalRecords = responseData.total;
        
        this.loading = false;
      } catch (error) {
         this.loading = false;
        this.$refs.toast.show("Unable to fetch the report details", "error");
      }
    },
 formatAPIDate(date) {
    if (!date) return null;
    const d = new Date(date);
    const day = (`0${d.getDate()}`).slice(-2);
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  },
  async fetchingDateReports() {
    if (
      !this.dateRange || 
      !Array.isArray(this.dateRange) || 
      this.dateRange.length < 2 || 
      !this.dateRange[0] || 
      !this.dateRange[1]
    ) {
      this.$refs.toast.show("Please select a valid date range.", "warning");
      return;
    }

    this.startDate = this.formatAPIDate(this.dateRange[0]);
   this.endDate = this.formatAPIDate(this.dateRange[1]);

    this.loading = true;
    try {
      const reportResponse = await NetworkService.get(
        `/transaction-list/${this.userId}?start_date=${this.startDate}&end_date=${this.endDate}&search=${this.searchValue}&per_page=${this.perpage}&page=${this.currentPage}`
      );
      const responseData = reportResponse.data;
        const reports = reportResponse.data.data;
        const startIndex = (this.currentPage - 1) * this.perpage;

        this.reportsData = reports.map((report, index) => {
          return {
            s_no: startIndex + index + 1,
            created_at: this.formatDate(report.created_at),
            transaction_id: report.urn,
            service_name: report.service_name || report.services?.name || "N/A",
            amount: report.amount ? `₹ ${report.amount}` : "₹ 0.00",
            payment_mode: report.payment_mode || "N/A",
            payment_status: report.status,
            id: report.id,
          };
        });
        this.totalRecords = responseData.total;
        this.loading = false;
     this.selectedDate = true;
    } catch (err) {
      this.$refs.toast.show("Unable to fetch filtered reports.", "error");
    } finally {
      this.loading = false;
    }
  },




downloadInvoice() {
  const invoice = this.selectedInvoice;
  if (!invoice) return;

  const doc = new jsPDF("p", "mm", "a4");

  // Styling constants
  const primaryColor = "#2c3e50";
  const accentColor = "#3498db";
  const tableHeaderBg = "#ecf0f1";
  const textColor = "#333333";
  const faintTextColor = "#7f8c8d";
  const marginX = 20;
  const rightColumnX = 140; 
  const textLineHeight = 5;

  let currentY = 20;

  // Invoice Title
  doc.setFontSize(24);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(accentColor);
  doc.text("INVOICE", doc.internal.pageSize.width / 2, currentY, { align: "center" });

  doc.setTextColor(textColor);
  currentY += 15;

  // Add Logo
  const logoUrl = "/images/makbilllogo.png";
  const img = new Image();
  img.src = logoUrl;
  img.crossOrigin = "Anonymous";

  img.onload = function () {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const logoBase64 = canvas.toDataURL("image/png");

    const logoY = currentY;
    doc.addImage(logoBase64, "PNG", marginX, logoY, 30, 30);

    // Invoice Details (remains on the right, typically)
    const invoiceDetailsX = rightColumnX;
    const invoiceDetailsValueX = 170;
    const invoiceDetailsY = logoY;

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Invoice No:", invoiceDetailsX, invoiceDetailsY + 10);
    doc.text("Date:", invoiceDetailsX, invoiceDetailsY + 15);
    if (invoice.urn) {
      doc.text("Transaction ID:", invoiceDetailsX, invoiceDetailsY + 20);
    }

    doc.setFont("helvetica", "normal");
    doc.text(`${invoice.id || ""}`, invoiceDetailsValueX, invoiceDetailsY + 10);
    doc.text(`${this.formatDate(invoice.created_at) || ""}`, invoiceDetailsValueX, invoiceDetailsY + 15);
    if (invoice.urn) {
      doc.text(`${invoice.urn}`, invoiceDetailsValueX, invoiceDetailsY + 20);
    }

    currentY = Math.max(logoY + 35, invoiceDetailsY + 20) + 10;
    let sectionStartY = currentY; 

    // Bill To (Left Column)
    let billToCurrentY = sectionStartY;
    doc.setFont("helvetica", "bold");
    doc.text("Bill To:", marginX, billToCurrentY);
    billToCurrentY += textLineHeight;

    doc.setFont("helvetica", "normal");
    doc.text("Name:", marginX, billToCurrentY);
    doc.setTextColor(faintTextColor);
    doc.text(`${invoice.name || "N/A"}`, marginX + 15, billToCurrentY);
    doc.setTextColor(textColor);
    billToCurrentY += textLineHeight;

    doc.text("Email:", marginX, billToCurrentY);
    doc.setTextColor(faintTextColor);
    doc.text(`${invoice.email || "N/A"}`, marginX + 15, billToCurrentY);
    doc.setTextColor(textColor);
    billToCurrentY += textLineHeight;

    doc.text("Mobile:", marginX, billToCurrentY);
    doc.setTextColor(faintTextColor);
    doc.text(`${invoice.mobile || "N/A"}`, marginX + 15, billToCurrentY);
    doc.setTextColor(textColor);
    billToCurrentY += textLineHeight;

    // --- Dynamic Address Formatting (Bill To) ---
    doc.text("Address:", marginX, billToCurrentY);
    doc.setTextColor(faintTextColor);

    const fullAddress = this.userAddress?.address || "N/A";
    const addressLines = [];

    const maxFirstLineChars = 45;

    if (fullAddress !== "N/A") {
        let firstLine = '';
        let remainingAddress = '';
        const parts = fullAddress.split(',');

        if (parts.length > 1) {
            // Try to build the first line until it's "long enough" or we run out of parts for it
            let currentLine = [];
            let currentLength = 0;
            let splitIndex = 0;

            for (let i = 0; i < parts.length; i++) {
                const part = parts[i].trim();
                if (currentLength + part.length + (i > 0 ? 1 : 0) <= maxFirstLineChars || i === 0) {
                    currentLine.push(part);
                    currentLength += part.length + (i > 0 ? 1 : 0); // +1 for comma space
                } else {
                    splitIndex = i;
                    break;
                }
                splitIndex = i + 1; // Mark the point right after this part
            }
            
            firstLine = currentLine.join(', ');
            remainingAddress = parts.slice(splitIndex).join(', ');

            if (remainingAddress.length < 5 && firstLine.length > (maxFirstLineChars / 2) && parts.length > 1) {
              
                const mid = Math.floor(parts.length / 2);
                firstLine = parts.slice(0, mid).join(', ');
                remainingAddress = parts.slice(mid).join(', ');
            }


        } else {
            firstLine = fullAddress; 
        }

        addressLines.push(firstLine.trim());
        if (remainingAddress) {
            addressLines.push(remainingAddress.trim());
        }

    } else {
        addressLines.push("N/A");
    }

    const addressValueX = marginX + 15;
    let addressY = billToCurrentY;

    if (addressLines.length > 0) {
        doc.text(addressLines[0], addressValueX, addressY);
        addressY += textLineHeight;
        for (let i = 1; i < addressLines.length; i++) {
            doc.text(addressLines[i], addressValueX, addressY);
            addressY += textLineHeight;
        }
    } else {
        doc.text(fullAddress, addressValueX, addressY);
        addressY += textLineHeight;
    }

    billToCurrentY = addressY; 
    doc.setTextColor(textColor);
    let serviceDetailsCurrentY = sectionStartY; 
    doc.setFont("helvetica", "bold");
    doc.text("Payment Details", rightColumnX, serviceDetailsCurrentY);
    serviceDetailsCurrentY += textLineHeight;

    doc.setFont("helvetica", "normal");
    doc.text("Payment Mode:", rightColumnX, serviceDetailsCurrentY);
    doc.setTextColor(faintTextColor);
    // doc.text(`${invoice.payment_mode  || "N/A"}`, rightColumnX + 28, serviceDetailsCurrentY);
    doc.text(this.formatPaymentMode(invoice.payment_mode || "N/A"), rightColumnX + 28, serviceDetailsCurrentY);
    doc.setTextColor(textColor);
    serviceDetailsCurrentY += textLineHeight;

    doc.text("Payment Status:", rightColumnX, serviceDetailsCurrentY);
    doc.setTextColor(faintTextColor);
    const descriptionText = invoice.payment_status  || "N/A";
    const splitDescription = doc.splitTextToSize(descriptionText, doc.internal.pageSize.width - rightColumnX - marginX - 28); // Adjust width for right column
    let descY = serviceDetailsCurrentY;
    splitDescription.forEach(line => {
      doc.text(line, rightColumnX + 28, descY);
      descY += textLineHeight;
    });
    serviceDetailsCurrentY = descY; 
    doc.setTextColor(textColor);
    currentY = Math.max(billToCurrentY, serviceDetailsCurrentY) + 10;

    // if (invoice.payment_mode) {
    //   doc.setFont("helvetica", "bold");
    //   doc.text("Payment Mode:", marginX, currentY);
    //   doc.setFont("helvetica", "normal");
    //   doc.text(this.formatPaymentMode(invoice.payment_mode), marginX + 30, currentY);
    //   currentY += 10;
    // }
    currentY += 10;
    const amount = parseFloat(invoice.amount || 0);
    const tableRows = [
      ["1", invoice.services?.name || "Service", "1", `${amount.toFixed(2)}`, `${amount.toFixed(2)}`],
      [
        { content: "", colSpan: 3 },
        { content: "Subtotal:", styles: { fontStyle: "bold", halign: "right" } },
        { content: `${amount.toFixed(2)}`, styles: { halign: "right" } }
      ],
      [
        { content: "", colSpan: 3 },
        {
          content: "Total:",
          styles: { fontStyle: "bold", halign: "right", fillColor: tableHeaderBg, textColor: primaryColor }
        },
        {
          content: `${amount.toFixed(2)}`,
          styles: { halign: "right", fillColor: tableHeaderBg, textColor: primaryColor }
        }
      ]
    ];

    autoTable(doc, {
      startY: currentY,
      head: [["#", "Description", "Qty", "Price", "Amount"]],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 3,
        textColor: textColor,
        lineColor: "#cccccc",
        lineWidth: 0.1
      },
      headStyles: {
        fillColor: tableHeaderBg,
        textColor: primaryColor,
        fontStyle: "bold",
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 15 },
        1: { cellWidth: "auto" },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "right", cellWidth: 30 },
        4: { halign: "right", cellWidth: 30 }
      },
      bodyStyles: {
        halign: "left"
      },
      didParseCell: function (data) {
        if (data.section === "body") {
          if (data.row.index === 0) {
            if (data.column.index === 3 || data.column.index === 4) {
              data.cell.styles.halign = "right";
            } else if (data.column.index === 0 || data.column.index === 2) {
              data.cell.styles.halign = "center";
            }
          } else if (data.column.index === 3) {
            data.cell.styles.halign = "right";
            data.cell.styles.fontStyle = "bold";
          } else if (data.column.index === 4) {
            data.cell.styles.halign = "right";
          }
        }
      }
    });

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(faintTextColor);
    doc.text("Thank you for your business!", marginX, doc.internal.pageSize.height - 15);
    doc.text("Powered by Makbill", doc.internal.pageSize.width - marginX, doc.internal.pageSize.height - 15, {
      align: "right"
    });

    doc.save(`Invoice_${invoice.id || "Unknown"}.pdf`);
  }.bind(this);
}
  },
};
</script>

<style scoped>

/* invoice in reports css */

.modal-title {
  font-size: 1.35rem; 
  font-weight: bold;
  text-align: center; 
  width: 100%; 
}

.logo-in-modal {
  max-width: 100px;
  height: auto;
}


.bill-to p,
.payment-mode p,
.date p {
  font-size: 0.9rem; 
  margin-bottom: 0.25rem; 
}
.user-table tr {
  font-size: 0.9rem;
}
table tbody td {
  font-size: 0.85rem;
}
.sub-total-text {
  font-size: 0.9rem;
}

</style>